import React from 'react';
import './CheckoutSuccess.css';
import { productLabel } from '../lib/catalogue';

const CheckoutSuccess = ({ checkoutData, customerData, product, quantity = 1 }) => {
    const units = Math.max(1, Number(quantity) || 1);
    const label = productLabel(product) || 'our product';
    return (
        <div className="checkout-success-container">
            <div className="success-icon-wrapper">
                <div className="success-icon">✓</div>
            </div>
            <h2>Order Successful!</h2>
            <p className="success-message">
                Thanks for buying <strong>{label}{units > 1 ? ` (${units} users)` : ''}</strong>! <br />
                We have sent an email with additional information to <strong>{customerData?.email || 'your email address'}</strong>.
            </p>

            <p className="support-info">
                If any issue or question occurs, we are here to help at <a href="mailto:support@spherene.io">support@spherene.io</a>.
            </p>

            {checkoutData?.transaction_id && (
                <p className="transaction-id">
                    Transaction ID: {checkoutData.transaction_id}
                </p>
            )}

            <div className="success-actions">
                <a href="https://spherene.io" className="return-home-btn">Return to Homepage</a>
            </div>
        </div>
    );
};

export default CheckoutSuccess;
